<template>
    <div>
        <div v-if="!hasError" class="s-press__list">
            <div v-for="(item, i) in results" :key="'press-result-' + i" class="s-press__list__item">
                <a :href="item.href" class="b-art-link">
                    <div v-if="item.img?.src?.length" class="b-art-link__photo-wrap">
                        <div class="b-art-link__photo">
                            <img
                                :src="item.img.src"
                                :alt="item.img.alt"
                                :width="item.img.width"
                                :height="item.img.height" />
                        </div>
                    </div>
                    <div class="b-art-link__info">
                        <div class="b-art-link__date">{{ item.date }}</div>
                        <div class="b-art-link__title">{{ item.title }}</div>
                        <div class="b-art-link__desc">{{ item.description }}</div>
                        <div v-if="item?.tags.length" class="b-art-link__tags">
                            <ul>
                                <li v-for="(tag, tag_i) in item.tags" :key="'item-' + i + '-tag-' + tag_i">
                                    <span class="e-tag">{{ tag }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="b-art-link__cta">{{ appData.dictionary.learnMore }}</div>
                    </div>
                </a>
            </div>
        </div>
        <ResponseError v-else :error-messages="errorMessages" />
    </div>
</template>

<script>
import ResponseError from 'Root/vue/components/ResponseError.vue'

export default {
    components: {
        ResponseError,
    },

    props: {
        results: {
            type: Array,
            default() {
                return []
            },
        },
        errorMessages: {
            type: String,
            default: '',
        },
        hasError: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
